
const MultiSelector = ({
    packages,
    onChange,
    label = "Package",
}) => {
    return (
        <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-medium text-gray-700 mr-1">
                {label}
            </span>

            {Object.keys(packages).map((pkg) => {
                const isSelected = packages[pkg];

                return (
                    <div
                        key={pkg}
                        onClick={() => onChange(pkg, !isSelected)}
                        className={`
                            px-3 py-1.5
                            rounded-full border
                            text-sm shadow-sm
                            transition-all duration-200
                            cursor-pointer
                            font-medium whitespace-nowrap
                            ${
                                isSelected
                                    ? "bg-blue-50 border-blue-600 text-blue-700"
                                    : "bg-white border-gray-200 text-gray-700"
                            }
                        `}
                    >
                        {pkg}
                    </div>
                );
            })}
        </div>
    );
};

export default MultiSelector;